import React, {useContext} from "react";
import {Col, Row, Button} from "antd";
import {ShiftRequestContext} from "../ShiftRequest";
import {SubCompanyFilter, CompanyFilter} from "../../_defaultComponents/FilterComponents";
import {PlusOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";

export const ShiftRequestHeader = () => {
    const {t} = useTranslation(["shiftRequest"]);
    const {
        selectedSubCompany,
        setSelectedSubCompany,
        setIsCreateModalOpen,
        selectedCompany,
        setSelectedCompany,
        setSelectedShiftRequest,
        setIsShiftRequestUpdating
    } = useContext(ShiftRequestContext);

    return (
        <Col span={24}>
            <Row gutter={[20, 20]}>
                <Col xs={24} sm={16} md={12} lg={8} xl={6}>
                    <CompanyFilter value={selectedCompany} onChange={setSelectedCompany} />
                </Col>
                <Col xs={24} sm={16} md={12} lg={8} xl={6}>
                    <SubCompanyFilter
                        value={selectedSubCompany}
                        onChange={setSelectedSubCompany}
                        company={selectedCompany}
                        disabled={!selectedCompany}
                        showAllOption={false}
                        allowClear={true}
                    />
                </Col>
            </Row>
            <Button
                type="primary"
                icon={<PlusOutlined />}
                disabled={!selectedSubCompany}
                onClick={() => {
                    setSelectedShiftRequest(null);
                    setIsShiftRequestUpdating(false);

                    setTimeout(() => {
                        setIsCreateModalOpen(true);
                    }, 100);
                }}
            >
                {t("createNewShiftRequest", {ns: "shiftRequest"})}
            </Button>
        </Col>
    );
};
